import { ThemeService } from './services/theme.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Languages from './languages';
import { ActivatedRoute } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public title = 'questionarioPOA-front';
  public loading = true;
  public currentLang = Languages.default;
  private themeWrapper = document.documentElement;

  constructor(private translate: TranslateService, private swUpdate: SwUpdate, private themeService: ThemeService) {
    this.translate.addLangs(['pt', 'en']);
    this.translate.setDefaultLang(this.currentLang);

  }

  checkUpdatesAndRefresh() {
    this.swUpdate.available.subscribe((event) => {
      console.log('Versão nova disponível, por favor refresh esta pagina!');
      this.swUpdate.activateUpdate().then(() => document.location.reload());
    });
  }

  i18nProvider(): void {
    const currentUrlLang: string = window.location.pathname.split('/')[1];

    const currentLang = Languages[currentUrlLang];

    if (!currentLang) {
      this.currentLang = Languages.default;
    }
    else {
      this.currentLang = currentLang.urlLang;
    }
    this.translate.use(this.currentLang);
    this.loading = false;
  }



  ngOnInit(): void {
    this.checkUpdatesAndRefresh();
    this.themeService.setBlendTheme();
    this.i18nProvider();
  }
}
